<template>
  <div class="videoBox" :class="{ detail: type === 'detail' }">
    <!-- <img :src="imgUrl" class="bg" /> -->
    <img :src="imgUrl" class="img" @click="showVideo" />
    <img
      src="@/assets/image/player.webp"
      class="icon"
      alt=""
      srcset=""
      @click="showVideo"
      v-if="!hideIcon"
    />
    <VideoDialog ref="VideoDialogRef" />
  </div>
</template>

<script>
import VideoDialog from "@/components/VideoDialog/index.vue";
export default {
  components: {
    VideoDialog,
  },
  props: {
    imgUrl: {
      type: String,
      default: "https://picsum.photos/230/300",
    },
    url: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
    hideIcon: {
      type: Boolean,
      default: false,
    },
    preview: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      videoVisible: false,
    };
  },
  created() {},
  computed: {},
  methods: {
    showVideo() {
      if (this.preview) {
        this.$refs.VideoDialogRef.showVideo(this.url);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.videoBox {
  position: relative;
  display: inline-block;
  vertical-align: middle;
  @include popupNo;
  img {
    vertical-align: middle;
  }
  .img {
    width: 200px;
    height: 112px;
    object-fit: contain;
    border-radius: 4px;
    position: relative;
    // backdrop-filter: blur(2px);
    background-color: #000000;
  }
  .bg {
    position: absolute;
    top: 0;
    left: 0;
    width: 200px;
    height: 112px;
    object-fit: cover;
    border-radius: 4px;
    filter: grayscale(50%) brightness(0.4) contrast(1.2);
  }
  .icon {
    width: 22px;
    height: 22px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.detail {
  .img {
    width: 610px;
    height: 342px;
  }
  .icon {
    width: 46px;
    height: 46px;
  }
}
</style>
